var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.125,
    width: 3.75,
    height: 12.5,
    rx: 1.875,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.125,
    y: 37.5,
    width: 3.75,
    height: 12.5,
    rx: 1.875,
    fill: "#9C9C9C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 23.125,
    width: 3.75,
    height: 12.5,
    rx: 1.875,
    transform: "rotate(90 50 23.125)",
    fill: "#E6E6E6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 23.125,
    width: 3.75,
    height: 12.5,
    rx: 1.875,
    transform: "rotate(90 12.5 23.125)",
    fill: "#595959"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 45.7131,
    y: 10.8762,
    width: 3.75,
    height: 12.5,
    rx: 1.875,
    transform: "rotate(60 45.7131 10.8762)",
    fill: "#EDEDED"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 13.2372,
    y: 29.6262,
    width: 3.75,
    height: 12.5,
    rx: 1.875,
    transform: "rotate(60 13.2372 29.6262)",
    fill: "#6A6A6A"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 35.8762,
    y: 2.41187,
    width: 3.75,
    height: 12.5,
    rx: 1.875,
    transform: "rotate(30 35.8762 2.41187)",
    fill: "#F0F0F0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 17.1262,
    y: 34.8877,
    width: 3.75,
    height: 12.5,
    rx: 1.875,
    transform: "rotate(30 17.1262 34.8877)",
    fill: "#848484"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 47.5881,
    y: 35.8762,
    width: 3.75,
    height: 12.5,
    rx: 1.875,
    transform: "rotate(120 47.5881 35.8762)",
    fill: "#D2D2D2"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1122,
    y: 17.1262,
    width: 3.75,
    height: 12.5,
    rx: 1.875,
    transform: "rotate(120 15.1122 17.1262)",
    fill: "#454545"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 39.1238,
    y: 45.7131,
    width: 3.75,
    height: 12.5,
    rx: 1.875,
    transform: "rotate(150 39.1238 45.7131)",
    fill: "#BABABA"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 20.3738,
    y: 13.2372,
    width: 3.75,
    height: 12.5,
    rx: 1.875,
    transform: "rotate(150 20.3738 13.2372)",
    fill: "#303030"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.3c94294e4a2689f3ec198a092f75cdb7.svg";
export { ForwardRef as ReactComponent };